module.exports = __webpack_public_path__ + "img/0036.c9f586ae.jpg";